module.exports = __webpack_public_path__ + "img/speaker.6608e4cc.svg";